import Community from "./pages/Community";
import Communities from "./pages/Communities";
import Section from "./pages/Section";
import Dashboard from "./pages/Dashboard";
import Insights from "./pages/Insights";
import Banking from "./pages/Banking";
import Member from "./pages/Member";
import Content from "./pages/Content";
import Material from "./pages/Material";
import CommunityConfig from "./pages/CommunityConfig";
import Components from "./pages/Components";
import FragmentsExamples from "./components/_fragments/examples";
import ScreenLayout from "Screen";

import { environment } from "./config";

const routes = {
  "": Communities,
  insights: Insights,
  dashboard: Dashboard,
  "/:slug": Community,

  ":slug/settings": CommunityConfig,
  ":slug/settings/:tab": CommunityConfig,
  ":slug/settings/:tab/:subtab": CommunityConfig,
  ":slug/settings/:tab/:subtab/:itemId": CommunityConfig,

  ":slug/section/:section": Section,
  ":slug/section/:section/:content": Content,

  ":slug/materials/:materialId": Material,

  banking: Banking,
  "banking/charges": Banking,
  "banking/subscriptions": Banking,
  "banking/anticipations": Banking,
  "banking/withdrawal": Banking,
  "banking/withdrawal/:action": Banking,
  "banking/chargebacks": Banking,
  "banking/chargebacks/:chargebackId": Banking,
  "user/:id": Member,
  components: Components,
  fragments: FragmentsExamples,

  'screen': ScreenLayout,
};

if (environment === "home") {
  routes["fragments"] = FragmentsExamples;
}

export default routes;
